import React from 'react';
import { NotificationSnackbar } from './NotificationSnackbar';
import { ConfirmDialog } from './ConfirmDialog';

/**
 * Conteneur principal pour tous les composants de notification
 * Combine Snackbar et ConfirmDialog
 */
export const NotificationContainer: React.FC = () => {
  return (
    <>
      <NotificationSnackbar />
      <ConfirmDialog />
    </>
  );
};
